module.exports = __webpack_public_path__ + "img/25.54cfe5d.jpg";